import { useMemo } from 'react'
import { ChainId } from '@pancakeswap/sdk'
import { useAccount, useProvider, useSigner } from 'wagmi'
import { useActiveChainId } from './useActiveChainId'

export const useProviderOrSigner = (withSignerIfPossible = true, forceArbitrum?: boolean) => {
  const { chainId } = useActiveChainId()
  const provider = useProvider({ chainId: forceArbitrum ? ChainId.ARBITRUM : chainId })
  const { address, isConnected } = useAccount()
  const { data: signer } = useSigner()

  return useMemo(
    () => (withSignerIfPossible && address && isConnected && signer ? signer : provider),
    [address, isConnected, provider, signer, withSignerIfPossible],
  )
}
